<template>
  <div>
    <position
      v-for="(position, index) in row"
      :key="index"
      :class="`col-md-${position.width} sticky-top`"
      :grid="grid"
      :position="position.columnId"
      :url="url"
      :params="params"
    />
  </div>
</template>

<script>
import Position from './Position'

export default {
  name: 'LayoutRow',
  components: {
    Position,
  },
  props: {
    grid: {
      type: Object,
      required: true,
    },
    row: {
      type: Array,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped></style>
